/*
 * Copyright (c) 2017 VMware, Inc. All Rights Reserved.
 * This software is released under MIT license.
 * The full license information can be found in LICENSE in the root directory of this project.
 */

import {AfterContentInit, Component, ContentChildren, EventEmitter, Input, Output, QueryList} from '@angular/core';
import {Alert} from './alert';
import {MultiAlertService} from './providers/multi-alert-service';
export class Alerts implements AfterContentInit {
     allAlerts: QueryList<Alert>;
/**
 * Input/Output to support two way binding on current alert index
 * @param {?} index
 * @return {?}
 */
public set _inputCurrentIndex(index: number) {
        if (index) {
            this.multiAlertService.current = index;
        }
    }
public currentAlertIndexChange = new EventEmitter<number>(false);
/**
 * @param {?} index
 * @return {?}
 */
set currentAlertIndex(index: number) {
        this.multiAlertService.current = index;
    }
/**
 * @return {?}
 */
get currentAlertIndex() {
        return this.multiAlertService.current;
    }
/**
 * Input/Output to support two way binding on current alert instance
 * @param {?} alert
 * @return {?}
 */
set currentAlert(alert: Alert) {
        if (alert) {
            this.multiAlertService.currentAlert = alert;
        }
    }
/**
 * @return {?}
 */
get currentAlert() {
        return this.multiAlertService.currentAlert;
    }
public currentAlertChange = new EventEmitter<Alert>(false);
/**
 * Ensure we are only dealing with alerts that have not been closed yet
 * @return {?}
 */
get alerts() {
        return this.allAlerts.filter((alert) => {
            return alert.isHidden === false;
        });
    }
/**
 * @return {?}
 */
get currentAlertType(): string {
        if (this.multiAlertService.currentAlert) {
            return this.multiAlertService.currentAlert.alertType;
        }
        return "";
    }
/**
 * @param {?} multiAlertService
 */
constructor(public multiAlertService: MultiAlertService) {}
/**
 * @return {?}
 */
ngAfterContentInit() {
        this.multiAlertService.manage(this.allAlerts);
        this.multiAlertService.changes.subscribe((index) => {
            this.currentAlertIndexChange.next(index);
            this.currentAlertChange.next(this.multiAlertService.currentAlert);
        });
    }
static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
    selector: "clr-alerts",
    template: `
      <clr-alerts-pager
              *ngIf="multiAlertService.count > 1"
              [clrCurrentAlertIndex]="currentAlertIndex">
      </clr-alerts-pager>
      <ng-content select="clr-alert"></ng-content>
    `,
    providers: [MultiAlertService],
    host: {
        "[class.alerts]": "true",
        "[class.alert-danger]": "this.currentAlertType == 'danger' || this.currentAlertType == 'alert-danger'",
        "[class.alert-info]": "this.currentAlertType == 'info' || this.currentAlertType == 'alert-info'",
        "[class.alert-success]": "this.currentAlertType == 'success' || this.currentAlertType == 'alert-success'",
        "[class.alert-warning]": "this.currentAlertType == 'warning' || this.currentAlertType == 'alert-warning'"
    },
    styles: [":host { display: block }"]
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
{type: MultiAlertService, },
];
static propDecorators: {[key: string]: DecoratorInvocation[]} = {
'allAlerts': [{ type: ContentChildren, args: [Alert, ] },],
'_inputCurrentIndex': [{ type: Input, args: ["clrCurrentAlertIndex", ] },],
'currentAlertIndexChange': [{ type: Output, args: ["clrCurrentAlertIndexChange", ] },],
'currentAlert': [{ type: Input, args: ["clrCurrentAlert", ] },],
'currentAlertChange': [{ type: Output, args: ["clrCurrentAlertChange", ] },],
};
}

function Alerts_tsickle_Closure_declarations() {
/** @type {?} */
Alerts.decorators;
/**
 * @nocollapse
 * @type {?}
 */
Alerts.ctorParameters;
/** @type {?} */
Alerts.propDecorators;
/** @type {?} */
Alerts.prototype.allAlerts;
/** @type {?} */
Alerts.prototype.currentAlertIndexChange;
/** @type {?} */
Alerts.prototype.currentAlertChange;
/** @type {?} */
Alerts.prototype.multiAlertService;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
